import { HttpLink } from '@apollo/client'
import { createLink } from '../createLink'

export function createHttpLink({
  uri,
  headers,
  authenticateLink = false,
  authToken,
  tokenFunction,
}: {
  uri?: string
  headers?: Record<string, string>
  authenticateLink?: boolean
  authToken?: string
  tokenFunction?: () => Promise<string | undefined>
}) {
  const link = new HttpLink({ uri, headers })

  if (!authenticateLink) {
    return link
  }

  return createLink(link, authToken, tokenFunction)
}
